// components/StatusAlert.tsx
import { Alert, AlertAction, type AlertProps } from "@relex-solutions/fragments"
import type { ReactNode } from "react"

interface StatusAlertProps {
  role?: string
  color: AlertProps["color"]
  message: ReactNode
  retry?: () => void
  retryLabel?: ReactNode
}

export function StatusAlert({ role = "alert", color, message, retry, retryLabel }: StatusAlertProps) {
  return (
    <Alert
      role={role}
      color={color}
      actions={retry && retryLabel ? <AlertAction onClick={retry}>{retryLabel}</AlertAction> : undefined}
    >
      {message}
    </Alert>
  )
}
